// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"440":"5ff1fa18","803":"e2f8b26b"}[chunkId] + ".css";
};